import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                this.close()
            }
        }

        document.addEventListener('keyup', this.closeBind)
    }

    toggle() {
        if(html.classList.contains('has-search-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        html.classList.add('has-search-open')
        setTimeout(() => {
            this.$('input')[0].focus()
        }, 300);
    }

    close() {
        html.classList.remove('has-search-open')
    }

    destroy() {
        super.destroy()

        document.removeEventListener('keyup', this.closeBind)
    }
}
